module.exports = __webpack_public_path__ + "img/conjunctival-hyperemia-1.5b397e03.jpg";